import { post } from "../utils/request";
import axios from "axios";
const TARGET_SERVER = process.env.VUE_ENV === "server";
const baseUrl = process.env.config.RRDH_HOST;

export default {
  pageList: query => post(baseUrl + "/rrbi/productionfront/getPage", query),
  update: query => post(baseUrl + "/rrbi/productionfront/update", query),
  select: id => post(baseUrl + "/rrbi/productionfront/select/" + id),
  delete: id => post(baseUrl + "/rrbi/productionfront/delete/" + id),
  getList: query => post(baseUrl + "/rrbi/productionfront/getList", query),

  save: query => post(baseUrl + "/rrbi/productionfront/save", query), //快速保存剧本

  updateCountNum: id => post(baseUrl + "/rrbi/productionfront/updateCountNum/" + id),

  getProductionPageRightList: query => post(baseUrl + "/rrbi/productionfront/getProductionPageRightList", query),
  getProductionPageHotList: query => post(baseUrl + "/rrbi/productionfront/getProductionPageHotList", query),




  //v2

  pageV2IndexList: query => post(baseUrl + "/rrbi/v2/index/getPage", query),
  pageV2PorductionList: query => post(baseUrl + "/rrbi/v2/belong/getProductionPage", query),
  pageV2PorductionListTags: query => post(baseUrl + "/rrbi/v2/belong/getProductionPageTags", query),
};

//服务器渲染  数据获取
export function fetchProductionDetail({ id, cookies }) {
  return axios.post(baseUrl + `/rrbi/productionfront/select/${id}`, {
    headers: getCommonHeader({ cookies })
  });
}

export function fetchWorks({ cookies }) {
  return axios.get(baseUrl + "/rrbi/productionfront/getList", {
    headers: getCommonHeader({ cookies })
  });
}

export function fetchWorksMeta({ id, cookies }) {
  return axios.post(baseUrl + `/rrbi/productionfront/selectMeta/${id}`, {
    headers: getCommonHeader({ cookies })
  });
}

export function fetchActivityList({ activityType, cookies }) {
  return axios.get(
    baseUrl +
    `/rrbi/activity/activity-all?activityType=`+activityType+`&page=1&pageSize=12&status=0&from=front&ti=`+new Date().getMilliseconds(),
    {
      headers: getCommonHeader({ cookies })
    }
  );
}
export function fetchActivityInfoDetail({ id, cookies }) {
  return axios.get(
      baseUrl +
      `/rrbi/activity/activity-one?id=${id}&ti=` +
      new Date().getMilliseconds(),
      {
        headers: getCommonHeader({ cookies })
      }
  );
}

export function fetchNewIndexProductionList({ id, cookies ,params}) {
  return axios.post(baseUrl + `/rrbi/v2/index/getPage`, params,{
    headers: getCommonHeader({ cookies })
  });
}
export function fetchNewProductionPage({ id, cookies ,params}) {
  return axios.post(baseUrl + `/rrbi/v2/belong/getProductionPage`, params,{
    headers: getCommonHeader({ cookies })
  });
}

export function fetchIndexRightChoList({ id, cookies ,params}) {
  return axios.post(baseUrl + `/rrbi/productionfront/getProductionPageRightList`, params,{
    headers: getCommonHeader({ cookies })
  });
}
// export function fetchNewProductionDetail({ id, cookies ,params}) {
//   return axios.post(baseUrl + `/rrbi/productionfront/select/${id}`, params,{
//     headers: getCommonHeader({ cookies })
//   });
// }






function getCommonHeader({ cookies }) {
  if (TARGET_SERVER && cookies) {
    return { cookie: getCookieString(cookies) };
  } else {
    return null;
  }
}

function getCookieString(cookies) {
  let cookieStr = "";
  for (var variable in cookies) {
    if (Object.prototype.hasOwnProperty.call(cookies, "variable")) {
      cookieStr += `${variable}=${encodeURIComponent(cookies[variable])}; `;
    }
  }
  return cookieStr;
}
